import { PDFDownloadLink } from "@react-pdf/renderer";
import { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { startLoadingFlowEngineCatalogs } from "../../app/actions/flowEngineActions";
import { FLOW_MODULE_DEFINITIONS, isListTableTrayVisualEnabledForProcess } from "../../app/helpers/flowEngineConfigHelper";
import FlowModuleListTrayTable from "../specialist-flow-engine/FlowModuleListTrayTable";
import { formatCatalogCiiuLastLevelLabel } from "../../app/helpers/helperCatalogs";
import { useSortableData } from "../../app/hooks/useSortableData";
import useModuleTableFields from "../../app/hooks/useModuleTableFields";
import FlowStateSemaphore from "../specialist-flow-engine/components/FlowStateSemaphore";
import FlowRecordHistoryModal from "../specialist-flow-engine/components/FlowRecordHistoryModal";
import SpecialistTableRowActions from "../specialist-flow-engine/SpecialistTableRowActions";
import { FlowListPhaseCell, FlowListEmptyRow, resolveFlowListEmptyColSpan, isCasePhaseTableField, getModuleListFieldHeaderLabel } from "../specialist-flow-engine/FlowListPhaseCells";
import ExportToExcelAlternative from "./ExportToExcelAlternative";
import ExportToPdfAlternativeDesign from "./ExportToPdfAlternativeDesign";
import moment from "moment";
import ReadMoreReadLess from "../generic-read-more/ReadMoreReadLess";

const TableAlternative = ({
  data,
  onEditRow,
  onDeleteRow,
  flowSelectionEnabled = false,
  selectedIds = [],
  onToggleRow,
  onToggleAll,
  onExcelApplied,
  canSelectRecord = null
}) => {
  
  const dispatch = useDispatch();
  const { items, requestSort, sortConfig } = useSortableData(data);
  const { t } = useTranslation();
  const flowEngine = useSelector((state) => state.flowEngine);
  const [historyRecord, setHistoryRecord] = useState(null);

  useEffect(() => {
    if (flowSelectionEnabled && !flowEngine.loaded && !flowEngine.loading) {
      dispatch(startLoadingFlowEngineCatalogs());
    }
  }, [dispatch, flowSelectionEnabled, flowEngine.loaded, flowEngine.loading]);

  const { listFieldsAlternative } = useSelector((state) => state.moduleConfig);
  const configuration = useSelector((state) => state.configuration);
  const listFields = useModuleTableFields("alternative", listFieldsAlternative);
  const trayVisual = isListTableTrayVisualEnabledForProcess(configuration, "alternative");
  const { listFullCatalogCiius } = useSelector((state) => state.catalogCiiu);

  const { listSeries, listMagnitudes, listSizes } = useSelector((state) => state.catalog);

  const getClassNamesFor = (name) => {
    if (!sortConfig) {
      return;
    }
    return sortConfig.key === name ? sortConfig.direction : undefined;
  };

  const getStyleSortI = (accessor, sortConfig) => {
    let styleSort;
    if (accessor === sortConfig?.key && sortConfig.direction === "ascending") {
      styleSort = "fa fa-fw fa-sort-down table-icon-color-sort";
    } else if (accessor === sortConfig?.key && sortConfig.direction === "descending") {
      styleSort = "fa fa-fw fa-sort-up table-icon-color-sort";
    } else {
      styleSort = "fa fa-fw fa-sort table-icon-color-sort-no";
    }
    return styleSort;
  };

  const ItemHeader = (itemIn) => {
    const { item } = itemIn;
    
    if (item.show_in_table && item.data_type !== 'buttons') {
      return (
        <th scope="col" className="th-table-cell-list" key={item.id}>
          <button onClick={() => requestSort(item.field)} className={`${getClassNamesFor(item.field)} th-table-button`}>
            {getModuleListFieldHeaderLabel(item, t, "alternative")}
            <i className={getStyleSortI(item.field, sortConfig)}></i>
          </button>
        </th>
      )
    }
  }

  const getObjectById = (id, arraySearch) => {
    const elementFound = arraySearch.find((ser) => ser.id === id);
    return elementFound;
  };

  const ItemRow = (itemIn) => {
    const { item } = itemIn;
    
    return (
      <Fragment>
        {listFields && listFields.length > 0 && (
          listFields.map((tech, index) => {

            if (tech.show_in_table && isCasePhaseTableField(tech)) {
              return (
                <FlowListPhaseCell key={`${item.id}-phase`} record={item} process="alternative" />
              )
            }
            else if (tech.show_in_table && tech.data_type === 'id') {
              
              return (
                <th scope="row" key={`${item.id}-id`}>{item.id}</th>
              )
            }
            else if (tech.is_in_bdd && tech.show_in_table && tech.data_type === 'integer') {
             
              const columnTo = tech.field;
             
              const textField = item[`${columnTo}`];

              let textShow = "";
              
              if (tech.field === 'catalogserie_id') {
                
                const objectShow = getObjectById(textField, listSeries);
                textShow = objectShow && objectShow.name;
                
              } else if (tech.field === 'catalogsize_id') {
                
                const objectShow = getObjectById(textField, listSizes);
                textShow = objectShow && objectShow.name;

              } else if (tech.field === 'catalogmagnitude_id') {
                
                const objectShow = getObjectById(textField, listMagnitudes);
                textShow = objectShow && objectShow.name;

              }

              return (
                <td className={tech.style_in_table} key={`${item.id}-${tech.field}`}>
                  {textShow}
                </td>
              )
            }
            else if (tech.show_in_table && tech.data_type === 'string') {
              const columnTo = tech.field;
              const rawField = item[`${columnTo}`];
              const textField = columnTo === 'catalogciiu_levels'
                ? formatCatalogCiiuLastLevelLabel(rawField, listFullCatalogCiius)
                : rawField;

              return (
                <td className={tech.style_in_table} key={`${item.id}-${tech.field}`}>
                  <ReadMoreReadLess
                    className={`${tech.style_in_table} read-more-less`}
                    buttonClassName='btn-read-more-less'
                    expandLabel="Leer más" 
                    collapseLabel="Leer menos" 
                    limit={tech.readmore_limit_table}
                  
                  >
                    {textField}
                  </ReadMoreReadLess>
                </td>
              )
            } else if (tech.show_in_table && tech.data_type === 'datetime') {
              const columnTo = tech.field;
              const textField = item[`${columnTo}`];
              return (

                <td key={`${item.id}-${tech.field}`}>{textField ? moment(textField).local().format("DD-MM-YYYY") : ""}</td>
              )
            } else if (tech.show_in_table && tech.data_type === 'buttons') {
              return null;
            }
          })
        )}
      </Fragment>
    )
  }

  const tab = "\u00A0";

  if (trayVisual) {
    return (
      <FlowModuleListTrayTable
        moduleProcess="alternative"
        data={data}
        onEditRow={onEditRow}
        onDeleteRow={onDeleteRow}
        flowSelectionEnabled={flowSelectionEnabled}
        selectedIds={selectedIds}
        onToggleRow={onToggleRow}
        onToggleAll={onToggleAll}
        onExcelApplied={onExcelApplied}
        canSelectRecord={canSelectRecord}
        editTipKey="alternative.page.edit"
        editTipFallback="Editar"
        deleteTipKey="alternative.page.delete"
        deleteTipFallback="Eliminar"
      />
    );
  }

  return (
    <div style={{ paddingRight: "25px", paddingLeft: "25px" }}>
      <div className="table-responsive">
        <table className="table table-bordered">
          {false && (
            <caption className="caption-down">
              <div className="d-flex justify-content-center">
                {t("label.export_to")}: {tab}
                {data && data.length > 0 && (
                  <ExportToExcelAlternative

                    data={items}
                  />
                )}
                {data && data.length > 0 && (
                  <PDFDownloadLink document={<ExportToPdfAlternativeDesign data={items} />} fileName="user_data.pdf">
                    {({ blob, url, loading, error }) => (loading ? "Loading document..." : <i className="fa fa-file-pdf fa-1x" aria-hidden="true" />)}
                  </PDFDownloadLink>
                )}
              </div>
            </caption>
          )}

          <thead className="">
            {/* Start Table Header Columns */}
            <tr>
              {flowSelectionEnabled && (
                <th scope="col" className="th-table-cell-list">
                  <input
                    type="checkbox"
                    checked={items.filter((row) => !canSelectRecord || canSelectRecord(row)).length > 0
                      && items.filter((row) => !canSelectRecord || canSelectRecord(row)).every((row) => selectedIds.includes(row.id))}
                    onChange={onToggleAll}
                    disabled={!items.some((row) => !canSelectRecord || canSelectRecord(row))}
                  />
                </th>
              )}
              {flowSelectionEnabled && (
                <th scope="col" className="th-table-cell-list text-center" title={t("general.flow-engine.semaphore.column-title", "Estado")}>
                  <i className="fa fa-circle" aria-hidden="true" />
                </th>
              )}
              <th scope="col" className="th-table-cell-list text-center">
                {t("general.flow-engine.table.actions", "Acciones")}
              </th>
              {listFields && listFields.length > 0 && (
                listFields.map((item, index) => {
                  return (
                    <ItemHeader
                      key={item.id}
                      item={item} />
                  )
                })
              )}
            </tr>
            {/* Start Table Header Columns */}
          </thead>

          <tbody>
            {/* Start Table Body Columns */}
            {data && data.length > 0 && (
              items.map((item, index) => {
                return (
                  <tr key={item.id}>
                    {flowSelectionEnabled && (
                      <td>
                        {(!canSelectRecord || canSelectRecord(item)) ? (
                          <input
                            type="checkbox"
                            checked={selectedIds.includes(item.id)}
                            onChange={() => onToggleRow?.(item.id)}
                          />
                        ) : null}
                      </td>
                    )}
                    {flowSelectionEnabled && (
                      <td className="text-center">
                        <FlowStateSemaphore
                          stateCatalogId={item.state_catalog_id}
                          onClick={() => setHistoryRecord(item)}
                        />
                      </td>
                    )}
                    <td className="text-center">
                      <SpecialistTableRowActions
                        record={item}
                        onEdit={() => onEditRow(item)}
                        onDelete={() => onDeleteRow(item)}
                        editTipKey="alternative.page.edit"
                        editTipFallback="Editar"
                        deleteTipKey="alternative.page.delete"
                        deleteTipFallback="Eliminar"
                        tooltipScope={`alternative-${item.id}`}
                        moduleProcess="alternative"
                        onExcelApplied={onExcelApplied}
                      />
                    </td>
                    <ItemRow
                      item={item} />
                  </tr>
                )
              })
            )}
            {(!data || data.length === 0) && (
              <FlowListEmptyRow colSpan={resolveFlowListEmptyColSpan(listFields, flowSelectionEnabled)} />
            )}
            {/* End Table Body Columns */}
          </tbody>
        </table>
      </div>
      {historyRecord && (
        <FlowRecordHistoryModal
          show
          onHide={() => setHistoryRecord(null)}
          record={historyRecord}
          moduleId={FLOW_MODULE_DEFINITIONS.alternative.moduleId}
          moduleProcess="alternative"
        />
      )}
    </div >
  );
};

export default TableAlternative;